import React from 'react'
import { Header2 } from '../utils/Header'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

import { MARKETING } from '../../utils/constants'

const ListItem = ({ level }) => {
  return MARKETING.points[level].map((item, i) => (
    <div key={i} className="text-lg ">
      <FontAwesomeIcon icon={faCheck} className="mr-2 text-green-500" />
      {item}
    </div>
  ))
}
const Renew = ({ onChange, defaultValue, standalone = true }) => {
  return (
    <div className="">
      {standalone && (
        <>
          <Header2>Renew your Wandering Labs Premium Membership</Header2>
          <p className="text-lg">Reach out with any questions or comments: info@wanderinglabs.com</p>
        </>
      )}

      <div className="mt-6"></div>
      <div className="flex items-center justify-around">
        <div className="text-5xl font-semibold tracking-wider">$30</div>
        <div className="">
          <ListItem level="renew" />
        </div>
      </div>
      <div className=""></div>
    </div>
  )
}

export default Renew
